/**
 * Summary text for a closed dimension filter trigger.
 */
export function buildDimensionFilterSummaryLabel(
	options: Array<{ value: string }>,
	selected: string[]
): string {
	if (options.length === 0) {
		return '';
	}
	if (selected.length === 0) {
		return 'None Selected';
	}

	const allValues = options.map(o => o.value);
	if (
		selected.length >= allValues.length &&
		allValues.every(v => selected.includes(v))
	) {
		return 'All Selected';
	}

	return `${selected.length} selected`;
}
